import { Capacitor } from '@capacitor/core';
import { supabase } from '@/lib/supabase/client';

// On web, detectSessionInUrl: true in the Supabase client handles the callback
// automatically. This module handles the native app.openipub://auth/callback
// deep link that fires when the user taps a magic link on iOS/Android.
export function initDeepLinks(): () => void {
  if (!Capacitor.isNativePlatform()) return () => {};

  let cleanup: (() => void) | undefined;

  import('@capacitor/app').then(({ App }) => {
    App.addListener('appUrlOpen', async ({ url }) => {
      if (!url.includes('/auth/callback')) return;

      // Convert the native URL scheme to a parseable HTTPS URL
      const parseable = url.replace('app.openipub://', 'https://app.openipub.placeholder');
      const { hash, searchParams } = new URL(parseable);

      // Implicit flow: tokens are in the hash fragment
      const hashParams = new URLSearchParams(hash.slice(1));
      const accessToken = hashParams.get('access_token') ?? searchParams.get('access_token');
      const refreshToken = hashParams.get('refresh_token') ?? searchParams.get('refresh_token');

      if (accessToken && refreshToken) {
        await supabase.auth.setSession({ access_token: accessToken, refresh_token: refreshToken });
        return;
      }

      // PKCE flow: exchange the code
      const code = hashParams.get('code') ?? searchParams.get('code');
      if (code) {
        await supabase.auth.exchangeCodeForSession(code);
      }
    }).then(handle => {
      cleanup = () => handle.remove();
    });
  });

  return () => cleanup?.();
}

export function getAuthRedirectUrl(): string {
  if (Capacitor.isNativePlatform()) return 'app.openipub://auth/callback';
  return `${window.location.origin}/auth/callback`;
}
